import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import './BackBtn.scss';

function BackBtn(props) {
	return (
		<div
			className={clsx('BackBtn', {
				...props.className ? {
					[props.className]: true
				} : {}
			})}
			{...typeof props.onClick === 'function' ? {
				onClick: props.onClick
			} : {}}
		>
			<FontAwesomeIcon icon={faChevronLeft} className="icon"/>
			<span className="text">Back</span>
		</div>
	);
};

export default BackBtn;
